module.exports = __webpack_public_path__ + "img/system22-mini.e013ddd6.png";